export default "__VITE_PUBLIC_ASSET__c8ec863c__"